import { render, staticRenderFns } from "./TemplateMapping.vue?vue&type=template&id=278698fb&scoped=true&"
import script from "./TemplateMapping.vue?vue&type=script&lang=js&"
export * from "./TemplateMapping.vue?vue&type=script&lang=js&"
import style0 from "./TemplateMapping.vue?vue&type=style&index=0&id=278698fb&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "278698fb",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardActions } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCard,VCardActions,VCol,VDataTable,VDialog,VRow})


/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/aims-dashboard/aims-dashboard/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('278698fb')) {
      api.createRecord('278698fb', component.options)
    } else {
      api.reload('278698fb', component.options)
    }
    module.hot.accept("./TemplateMapping.vue?vue&type=template&id=278698fb&scoped=true&", function () {
      api.rerender('278698fb', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/lcd/views/Template/TemplateMapping.vue"
export default component.exports